import gql from 'graphql-tag';

export default gql`
mutation updateDonation ($id: ID!, $name: String, $cms_url: String, $active: DonationActiveDates) {
    updateDonation (input: {
        id: $id,
        name: $name,
        cms_url: $cms_url,
        active: $active,
    }) {
        id
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateDonation.ts